<template>
  <!-- 顶部栏 -->
  <el-container>
    <el-aside width="auto" class="header-logo tap">
      <h3>{{ title }}会员中心管理</h3>
    </el-aside>
    <el-aside width="auto" class="header-logo tap">
      <el-avatar icon="el-icon-user-solid" class="headerLogo"> </el-avatar>
      <!-- <div class="login-text">GIADA店铺操作员</div> -->
      <!-- 用户名下拉菜单 -->
      <el-dropdown class="login-text" @command="handleCommand">
        <span class="el-dropdown-link">
          {{ name }}
          <i class="el-icon-caret-bottom" style="color: #fff"></i>
        </span>

        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="one">个人中心</el-dropdown-item>
          <el-dropdown-item command="four">选择品牌</el-dropdown-item>
          <el-dropdown-item command="three">修改密码</el-dropdown-item>
          <el-dropdown-item command="two">退出登录</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>

      <el-dialog
        :close-on-click-modal="false"
        width="20%"
        title="品牌选择"
        :visible.sync="changeBrandShow"
      >
        <div style="display:flex;justify-content: center;">
          <el-radio-group v-model="cpyNo">
            <div v-for="(item, index) in dataList" :key="index" style="padding:10px 0;">
              <el-radio :label="item.cpyNO">{{ item.companyName }}</el-radio>
            </div>
          </el-radio-group>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="changecpyNo()">确 定</el-button>
          <el-button @click="changeBrandShow = false">取 消</el-button>
        </div>
      </el-dialog>
    </el-aside>
  </el-container>
</template>

<script>
import { mapActions } from "vuex";
import { getUserRights } from "@/api/login.js";
import { companyListApi,exchange } from "../../api/login";

export default {
  data() {
    return {
      changeBrandShow: false,
      username: "店铺操作员",
      name: "",
      dataList: [],
      cpyNo: undefined,
    };
  },
  computed: {
    title() {
      return localStorage.getItem('cpyName') || '';
    }
  },
  created() {
    getUserRights({}).then((res) => {
      this.name = res.empName + "(" + res.empCode + ")";
    });
  },
  methods: {
    ...mapActions({
      logout: "user/logout",
    }),
    handleCommand(command) {
      if (command === "two") {
        this.$confirm("您是否确认退出登录？", "警告")
          .then(() => {
            // 提示退出成功
            this.$message.success("退出成功");
            // 点击确定
            this.logout();
            //  跳转到登录页面
            this.$router.push("/");
            localStorage.removeItem("token");
          })
          .catch(() => {
            console.log("取消");
          });
      }
      if (command === "three") {
        this.$router.push("/ChangePassword");
      }
      if (command === "four") {
        this.cpyNo = localStorage.getItem("cpyNo");
        this.companySwitching();
        this.changeBrandShow = true;
      }
    },
    async companySwitching() {
      await companyListApi().then((res) => {
        this.dataList = res.data;
      });
    },
    changecpyNo() {
     if (!this.cpyNo) {
        this.$message.error("请选择公司品牌");
        return;
      } else {
        exchange({
          cpyNO: this.cpyNo,
        }).then((res) => {
          localStorage.setItem('token',res.access_token);
          location.reload();
        });
        localStorage.setItem("cpyNo", this.cpyNo);
        this.changeBrandShow = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.el-aside {
  display: flex;
  justify-content: center;
  align-items: center;
}
.login-text {
  color: #fff;

  margin-left: 15px;
  line-height: 40px;
  // background-color: #ccc;
}
h3 {
  font-size: 28px;
  font-weight: 400;
  color: #fff;
}

section {
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
}

.headerLogo,
.logo {
  /* 鼠标移入变成小手样式 */
  cursor: pointer;
}
</style>
